import { render, staticRenderFns } from "./Main.vue?vue&type=template&id=dc0f11dc&scoped=true&"
import script from "./Main.vue?vue&type=script&lang=js&"
export * from "./Main.vue?vue&type=script&lang=js&"
import style0 from "./Main.vue?vue&type=style&index=0&id=dc0f11dc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dc0f11dc",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/tgs-automation/tgs-automation/mojaweb/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('dc0f11dc')) {
      api.createRecord('dc0f11dc', component.options)
    } else {
      api.reload('dc0f11dc', component.options)
    }
    module.hot.accept("./Main.vue?vue&type=template&id=dc0f11dc&scoped=true&", function () {
      api.rerender('dc0f11dc', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Packages/Captures/components/Main.vue"
export default component.exports